module.exports = __webpack_public_path__ + "static/img/img_j.572157d7.png";